import { useEffect, useRef } from 'react'
import axios from 'axios'

const API = `${process.env.REACT_APP_BACKEND_URL}/api`

/**
 * Hook to track when user opens the app
 * Records the timestamp to enable inactivity notifications
 */
export function useAppOpenTracker() {
  const hasRecorded = useRef(false)
  
  useEffect(() => {
    // Only record once per session
    if (hasRecorded.current) return
    
    const recordAppOpen = async () => {
      try {
        // Get auth token from localStorage
        const token = localStorage.getItem('token')
        if (!token) return
        
        await axios.post(`${API}/auth/app-opened`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        })
        
        hasRecorded.current = true
      } catch (error) {
        // Silently fail - not critical
        console.debug('Failed to record app open:', error.message)
      }
    }
    
    // Small delay to ensure auth is ready
    const timer = setTimeout(recordAppOpen, 1000)
    return () => clearTimeout(timer)
  }, [])
}

/**
 * Hook to update user's preferred notification time
 */
export function useNotificationSettings() {
  const updatePreferredTime = async (time) => {
    try {
      const token = localStorage.getItem('token')
      if (!token) return false
      
      await axios.put(`${API}/auth/notification-settings`, {
        preferred_reminder_time: time
      }, {
        headers: { Authorization: `Bearer ${token}` }
      })
      
      return true
    } catch (error) {
      console.error('Failed to update notification settings:', error)
      return false
    }
  }
  
  const toggleNotifications = async (enabled) => {
    try {
      const token = localStorage.getItem('token')
      if (!token) return false
      
      await axios.put(`${API}/auth/notification-settings`, {
        notifications_enabled: enabled
      }, {
        headers: { Authorization: `Bearer ${token}` }
      })
      
      return true
    } catch (error) {
      console.error('Failed to update notification settings:', error)
      return false
    }
  }
  
  return { updatePreferredTime, toggleNotifications }
}
